import React, { KeyboardEvent, MouseEvent } from "react";
import styles from "./ota-install-action-button.module.scss";
import { ToolTip } from "../tooltip/tooltip";

type OTAInstallActionButtonVariant = "primary" | "secondary";

type OTAInstallActionButtonProps = {
  text: string;
  variant: OTAInstallActionButtonVariant;
  fun: (e: MouseEvent | KeyboardEvent) => void;
  disabled?: boolean;
  tooltip?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const cssClassName = "ota-install-action-button";

const OTAInstallActionButton = ({
  text,
  variant,
  fun,
  disabled = false,
  tooltip = "",
  ...rest
}: OTAInstallActionButtonProps) => {
  const button = (
    <button
      disabled={disabled}
      onClick={fun}
      className={`${styles[cssClassName]} ${
        styles[`${cssClassName}--${variant}`]
      }`}
      {...rest}
    >
      {text}
    </button>
  );
  return tooltip.trim().length > 0 ? (
    <ToolTip content={tooltip}>{button}</ToolTip>
  ) : (
    button
  );
};

export { OTAInstallActionButton };
